import { render, staticRenderFns } from "./RadioIcon.vue?vue&type=template&id=135ac28e"
import script from "./RadioIcon.vue?vue&type=script&lang=js"
export * from "./RadioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports